import {cr, interact} from 'fire-wind-water';
import {sxhr, sxhrRequest, sxhrHeaders} from 'fire-wind-water/sxhr';

sxhrRequest(config => {
  if (config.method === 'post' || config.method === 'POST') {
    cr.extend(true, config.data, {browseInfo: interact.browseInfo});
  }
  return config;
});
sxhrHeaders('Content-Type', 'text/plain');

export function $http(path, info, config) {
  const url = `${window.$sk_template.apiUrl}/${path}`;
  return new Promise((resolve, reject) => {
    sxhr.post(url, info, config).then(res => {
        resolve(res.data.body);
      }, err => {
        if (err.response && err.response.status == 401) {
          reject({result: 401, desc: '接口错误', data: err});
        } else {
          reject({result: 1317, desc: '接口错误', data: err});
        }
      }
    ).catch(error => {
      reject(error);
    });
  });
}

export function $get(url, config) {
  return new Promise((resolve, reject) => {
    sxhr.get(`${window.$sk_template.apiCacheUrl}${url}.json?time_stamp=${new Date().getTime()}`, config).then(res => {
        resolve(res.data.body);
      }, err => {
        if (err.response && err.response.status == 401) {
          reject({result: 401, desc: '接口错误', data: err});
        } else {
          reject({result: 1317, desc: '接口错误', data: err});
        }
      }
    ).catch(error => {
      reject(error);
    });
  });
}

export function $upload(info) {
  let url = `${window.$sk_template.sbaseUrl}?command=`;
  let command = encodeURI(
    JSON.stringify({
      size: 0,
      dst: '01-0300',
      orn: '01-0300',
      sess: '',
      type: 0x0002,
      cmd: 'file.upload',
      seq: 0,
      ver: 1000,
      body: ''
    })
  );
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    url: url + command
  };
  return new Promise((resolve, reject) => {
    sxhr.post(url + command, info, config).then(res => {
        resolve(res.data.body);
      }, err => {
        if (err.response && err.response.status == 401) {
          reject({result: 401, desc: '接口错误', data: err});
        } else {
          reject({result: 1317, desc: '接口错误', data: err});
        }
      }
    ).catch(error => {
      reject(error);
    });
  });
}